import React from "react";
const IconClose = ({ className }) => /* @__PURE__ */ React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  className,
  focusable: false
}, /* @__PURE__ */ React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("g", {
  transform: "translate(-674 -1466) translate(370 1434)"
}, /* @__PURE__ */ React.createElement("g", {
  transform: "translate(304 32)"
}, /* @__PURE__ */ React.createElement("rect", {
  width: "24",
  height: "24",
  rx: "12"
}), /* @__PURE__ */ React.createElement("path", {
  fill: "#192325",
  fillRule: "nonzero",
  d: "M7.613 6.21l.094.083L12 10.585l4.293-4.292c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094L13.415 12l4.292 4.293c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083L12 13.415l-4.293 4.292c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L10.585 12 6.293 7.707c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083z"
})))));
var IconClose_default = IconClose;
export {
  IconClose_default as default
};
